import GqlData from "../gql_data";

const loginInfoGqlc = (token: string, siteId: number): string => {
    return '?query=onl_all_full_loginInfo(siteId:' + siteId + ')&rnd=' + token.substring(token.length-5);
};

const loginInfoQuery = (token: string, siteId: number): GqlData => {
    return {
        query: `query loginInfo($token: String! $siteId: Int!)
            {
                loginInfo(token: $token, siteId: $siteId)
                {
                    id token email avatar nickname
                    deviceId profileId status subscriptionUntil
                    profileType
                }
            }`,
        variables: { token, siteId }
    }};

const loginUserQuery = (email: string, password: string, siteId: number): GqlData => {
    return {
        query: `query loginUser($email: String! $siteId: Int! $password: String!)
            {
                login(email: $email, siteId: $siteId, password: $password)
                {
                    id token email avatar nickname
                    deviceId profileId status subscriptionUntil
                }
            }`,
        variables: { email, siteId, password }
    }
};

const loginWithDeviceQuery = (deviceName: string, deviceFamily: string, siteId: number): GqlData => {
    return {
        query: `query LoginDevice($deviceName: String!, $deviceFamily: String!, $siteId: Int)
            {
                loginDevice(deviceName: $deviceName, deviceFamily: $deviceFamily, siteId: $siteId)
                {
                    id token email avatar nickname
                    deviceId profileId status subscriptionUntil
                }
            }`,
        variables: { deviceName, deviceFamily, siteId }
    }
};

const logoutUserQuery = (): GqlData => {
    return {
        query: `query logoutJwt
            {
                logoutJwt
                {
                    status
                }
            }`,
        variables: {}
    }
}

const loginProfileQuery = (profileId: number): GqlData => {
    return {
        query: `query loginProfile($profileId: Int!)
            {
                loginProfile(profileId: $profileId)
                {
                    id token email avatar nickname
                    deviceId profileId status subscriptionUntil
                }
            }`,
        variables: { profileId }
    }
};

const registerEmailOnlyQuery = (email: string, siteId: number, mailingId: number, sendUnsubscribeEmail: boolean): GqlData => {
    return {
        query: `mutation registerEmailOnly($email: String! $siteId: Int! $mailingId: Int! $sendUnsubscribeEmail: Boolean!)
            {
                registerEmailOnly(email: $email, siteId: $siteId, mailingId: $mailingId, sendUnsubscribeEmail: $sendUnsubscribeEmail)
                {
                    email
                }
            }`,
        variables: { email, siteId, mailingId, sendUnsubscribeEmail }
    }
};

const linkDeviceToUser = (deviceFamily: string, deviceName: string, deviceModel: string): GqlData => {
    return {
        query: `query LinkDeviceToUser($deviceFamily: String! $deviceName: String! $deviceModel: String!)
            {
                linkDeviceToUser(
                        deviceFamily: $deviceFamily
                        deviceName: $deviceName
                        deviceModel: $deviceModel
                ) {
                    id token email avatar nickname
                    deviceId profileId status subscriptionUntil
                }
            }`,
        variables: {deviceFamily,  deviceName, deviceModel }
    }
}

export {
    loginInfoQuery,
    loginInfoGqlc,
    registerEmailOnlyQuery,
    loginUserQuery,
    loginWithDeviceQuery,
    logoutUserQuery,
    loginProfileQuery,
    linkDeviceToUser
}

